import app from 'flarum/common/app';
import Model from 'flarum/common/Model';
export default class Subscription extends Model {
  id() {
    return Model.attribute('id').call(this);
  }
  amount() {
    return new Intl.NumberFormat('en-EN', {
      style: 'currency',
      currency: this.currency()
    }).format(Model.attribute('amount').call(this) / 100);
  }
  currency() {
    return Model.attribute('currency').call(this);
  }
  active() {
    return !!Model.attribute('active').call(this);
  }
  status() {
    return Model.attribute('status').call(this);
  }
  interval() {
    const interval = Model.attribute('interval').call(this);
    const intervalCount = Model.attribute('intervalCount').call(this);
    if (!interval) return app.translator.trans('floxum-payments.forum.stripe.interval_once');
    return (intervalCount > 1 ? intervalCount + ' ' : '') + interval + (intervalCount > 1 ? 's' : '');
  }
  paymentType() {
    return Model.attribute('paymentType').call(this);
  }
  cancellable() {
    return !!Model.attribute('cancellable').call(this);
  }
  relatesTo() {
    return Model.hasOne('relatesTo').call(this);
  }
  apiEndpoint() {
    return '/floxum-subscriptions';
  }
}
flarum.reg.add('floxum-payments', 'common/Subscription', Subscription);